module.exports = {
  back: 'Back',
  cancel: 'Cancel',
  confirm: 'Confirm',
  send: 'Send',
};



// WEBPACK FOOTER //
// ./js/lang/en/actions.js